import { registerPlugin } from '@capacitor/core';
const ImageManipulator = registerPlugin('ImageManipulator', {
    web: () => import('./web').then((m) => new m.ImageManipulatorWeb()),
});
export * from './definitions';
export { ImageManipulator };
//# sourceMappingURL=index.js.map